import React from "react";
interface Props {
  tableHeader: any[];
  extraHeader?: boolean;
  textCenter?: boolean;
  rowSpan?: boolean;
  type?: string;
}
const Gstr3BSixPointOneTableHeader = ({
  tableHeader = [],
  extraHeader,
  textCenter,
  type,
  rowSpan,
}: Props) => {
  return (
    <>
      <tr>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          rowSpan={2}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          Description
        </th>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          rowSpan={2}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          Total tax payable
        </th>
        {/* <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          rowSpan={2}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          NO. OF RECORDS
        </th> */}
        <th
          rowSpan={1}
          colSpan={4}
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          Tax paid through ITC
        </th>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg`}
          rowSpan={2}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          Tax paid in cash
        </th>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg`}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
          rowSpan={2}
        >
          Interest paid in cash
        </th>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg`}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
          rowSpan={2}
        >
          Late fee paid in cash
        </th>
      </tr>
      <tr>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          Integrated Tax
        </th>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          Central Tax
        </th>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          State/UT Tax
        </th>
        <th
          className={`${textCenter ? "text-center" : null} ${
            type ? "gstr_head" : "name"
          }  th-lg text-nowrap `}
          style={{
            backgroundColor: "#f3f6f8 !important",
            color: "#495057 !important",
          }}
        >
          CESS
        </th>
      </tr>
    </>
  );
};

export default Gstr3BSixPointOneTableHeader;
